import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../common/theme/ISpcTheme';

export type TransferActionsClasses = 'container' | 'button';

const transferActionsStyles = makeStyles<ISpcTheme, TransferActionsClasses>(
  theme => ({
    container: {
      position: 'sticky',
      bottom: 0,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-around',
      alignItems: 'center',
      background: theme.palette.common.white,
      flexWrap: 'wrap',
      padding: '20px 20px 0 20px',
      [theme.breakpoints.down('sm')]: {
        padding: '10px 10px 0 10px',
      },
    },
    button: {
      maxWidth: 'initial',
      marginBottom: 20,
      paddingTop: 10,
      paddingBottom: 10,
      width: 'auto',
      [theme.breakpoints.down('sm')]: {
        paddingTop: 7,
        paddingBottom: 7,
        minWidth: 280,
        marginBottom: 10,
      },
    },
  }),
  { name: 'GQL_Stock_TransferActions' },
);

export default transferActionsStyles;
